import { Component, EventEmitter, inject, NgZone, OnInit, Output } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, RouterLink } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../class/user.class';
import { SessionStorageService } from '../../services/sessionl-storage.service';

@Component({
  selector: 'oaj-header-itx',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  imports: [RouterLink],
})
export class HeaderComponent implements OnInit {

  modalOptions!: NgbModalOptions;
  closeResult!: string;
  Usuario: User = new User;
  @Output() home!: EventEmitter<any>;
  organosAutorizados = 0;
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private router: Router = inject(Router);
  private zone: NgZone = inject(NgZone);
  private authService: AuthService = inject(AuthService);
  bOrganoSupervisor = false;
  bBajoSupervision = false;

  constructor() {
    this.home = new EventEmitter();
  }

  ngOnInit(): void {
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    this.Usuario = currentUser ?? new User();
    this.organosAutorizados = this.authService.getOrganosAutorizados();
    this.bOrganoSupervisor = this.Usuario.cuentaConSupervision;
    this.bBajoSupervision=this.Usuario.bajoSupervision;
  }

  logout() {
    this.authService.logout();
    this.zone.run(() => {
      this.router.navigateByUrl('/login');
    });
  }

  ChangeCourt() {
    this.zone.run(() => {
      this.router.navigate([`ChangeCourt/true`]);
    });
  }


}
